export default {
  meetingTypes: {
    basicByUrl: { url: 'public/meetingType/basicByUrl', method: 'GET' },
    slot: { url: 'public/meetingType/slot', method: 'GET' }
  },
  meetings: {
    get: { url: 'public/meeting', method: 'GET' },
    create: { url: 'public/meeting', method: 'POST' },
    cancel: { url: 'public/meeting/cancel', method: 'POST' },
    reschedule: { url: 'public/meeting/reschedule', method: 'POST' }
  },
  settings: {
    get: { url: 'public/generalSettings', method: 'GET' }
  }
}
